function none() {}

export default function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selector.js
// module id = 95
// module chunks = 0